import * as React from 'react';

/**
 * When true, ALL datasheet fields are forced non-editable (empty + grayed out).
 * Used in pedigree split-view when no individual is selected or when
 * multiple individuals are selected.
 */
export const DatasheetForceDisabledContext = React.createContext(false);

export const useForceDisabled = () => React.useContext(DatasheetForceDisabledContext);
